import { switchMap } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { MatterTypeService } from '../../../services/matters/matter-type.service';

import { MatterType } from '../../../models/matter-type';

@Component({
  selector: 'app-matter-type-edit',
  templateUrl: './matter-type-edit.component.html',
  styleUrls: ['./matter-type-edit.component.css'],
})
export class MatterTypeEditComponent implements OnInit {
  matterType: MatterType = new MatterType();

  constructor(private matterTypeService: MatterTypeService, private route: ActivatedRoute) {
    this.route.params.pipe(switchMap((params: Params) => this.matterTypeService.editMatterType(params['id']))).subscribe((matter_type) => {
      this.matterType = matter_type;
    });
  }

  ngOnInit() {}
}
